// extracted by mini-css-extract-plugin
export default {"wrapper":"RecordAddress_wrapper__q7HdD","card":"RecordAddress_card__hycGf","header":"RecordAddress_header__Oyo+u"};